module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "beast-menu"
  }, [_c('div', {
    staticClass: "menu-wrap"
  }, [_c('div', {
    staticClass: "menu-member"
  }, [_c('div', {
    staticClass: "member-logo"
  }, [(_vm.member) ? _c('img', {
    attrs: {
      "src": _vm.member && _vm.member.level.avatarUrl
    }
  }) : _c('img', {
    attrs: {
      "src": require("../assets/icon-nologin.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "member-infos"
  }, [_c('div', {
    staticClass: "member-name"
  }, [_vm._v(_vm._s(_vm.member && _vm.member.profile.nickName))]), _vm._v(" "), (_vm.member) ? _c('div', {
    staticClass: "member-account"
  }, [_vm._m(0)]) : _c('div', {
    staticClass: "member-account no-login"
  }, [_vm._m(1)])]), _vm._v(" "), _c('span', {
    staticClass: "close-member",
    on: {
      "click": _vm.closeMenu
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "menu-list"
  }, [_c('div', {
    staticClass: "menu-group"
  }, [_c('div', {
    staticClass: "menu-item"
  }, [_c('h2', {
    on: {
      "click": function($event) {
        return _vm.jump(null, {
          type: 'index',
          value: ''
        }, $event)
      }
    }
  }, [_vm._v("首页")])]), _vm._v(" "), _vm._l((_vm.menu), function(item) {
    return _c('div', {
      staticClass: "menu-item"
    }, [_c('h2', {
      on: {
        "click": function($event) {
          return _vm.jump(item.data.subCategory, item.data.link, $event)
        }
      }
    }, [_vm._v(_vm._s(item.data.title)), (item.data.subCategory.length) ? _c('i') : _vm._e()]), _vm._v(" "), (item.data.subCategory.length) ? _c('ul', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.expand),
        expression: "item.expand"
      }],
      staticClass: "menu-item-child",
      attrs: {
        "data-show": item.expand && 'block'
      }
    }, _vm._l((item.data.subCategory), function(child) {
      return _c('li', {
        staticClass: "menu-child-item",
        on: {
          "click": function($event) {
            return _vm.jump(null, child.link, $event)
          }
        }
      }, [_vm._v("\n              " + _vm._s(child.title) + "\n            ")])
    }), 0) : _vm._e()])
  }), _vm._v(" "), _c('div', {
    staticClass: "menu-item"
  }, [_c('h2', {
    on: {
      "click": function($event) {
        return _vm.jump(null, {
          type: 'custom',
          value: ''
        }, $event)
      }
    }
  }, [_vm._v("高级定制")])]), _vm._v(" "), _c('div', {
    staticClass: "menu-item"
  }, [_c('h2', {
    on: {
      "click": function($event) {
        return _vm.jump(null, {
          type: 'discount',
          value: ''
        }, $event)
      }
    }
  }, [_vm._v("折扣优惠")])]), _vm._v(" "), _c('div', {
    staticClass: "menu-item"
  }, [_c('h2', {
    on: {
      "click": function($event) {
        return _vm.jump(null, {
          type: 'retail',
          value: ''
        }, $event)
      }
    }
  }, [_vm._v("实体店")])])], 2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "/my"
    }
  }, [_vm._v("我的账号"), _c('i')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "/my"
    }
  }, [_vm._v("登录/快速注册"), _c('i')])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52a93840"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./static/components/app-menu/components/main.vue
// module id = 204
// module chunks = 1 2 3 4 5 6 7 8 9 10 12 13 14 16 17 19 21 26 28 29 31 36 37 40 42